import React from 'react';
import HomeIcon from "../../assets/images/icon/home_icon.svg";

interface IProps {
    path: string
}

const HeaderPath:React.FC<IProps> = ({path}) => {

    return (
        <div className={'flex items-center gap-[6px] mb-[63px]'}>
            <img className={'w-[12px]'} src={HomeIcon} alt="홈 아이콘"/>
            <span className={'leading-none text-[#565656] font-[400] text-[14px]'}>
                {path}
            </span>
        </div>
    )
}


export default HeaderPath;
